import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageWrapper } from '../../components/PageWrapper';
import { CreateSubscription } from './CreateSubscription';

export const CreateSubscriptionPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <PageWrapper title={t('CREATE_SUBSCRIPTION_PAGE.TITLE')}>
            <CreateSubscription />
        </PageWrapper>
    );
};
